import React, {Component} from 'react';

import Popup from '../Popup/index';
import ChatEditorTextColorPopup from '../ChatEditorTextColorPopup/index';

import {uniqueId} from '../../../utils'
import * as utils from '../ChatEditorOwn/utils';

import './styles.scss';

class ChatEditorTextStylePopup extends Popup {

    constructor(props) {
        super(props);

        this._onBoldClick = this._onBoldClick.bind(this);
        this._onItalicClick = this._onItalicClick.bind(this);
        this._onFontSizeChange = this._onFontSizeChange.bind(this);
        this._onFontFamilyChange = this._onFontFamilyChange.bind(this);
    }
    
    position() {
        if (!this.$anchor || this.$anchor.length === 0) return;

        var offset = this.$anchor.offset(),
            width = this.$popup.width(),
            height = this.$popup.height();

        var left = offset.left - width + 44,
            top = offset.top - height - 23;

        if (left + width > window.innerWidth) left = window.innerWidth - width;

        this.$popup.css({
            left: left + "px",
            top: top + "px"
        });
    }

    _getState(props) {
        return {
            bold: utils.isBold(props.editorStyle),
            italic: utils.isItalic(props.editorStyle),
            fontSize: props.editorStyle.fontSize,
            fontFamily: props.editorStyle.fontFamily,
            color: props.editorStyle.color
        };
    }

    _onBoldClick() {
        let {dispatch} = this.props;
        dispatch({type: 'EDITOR_BOLD'});
        this.close();
    }

    _onItalicClick() {
        let {dispatch} = this.props;
        dispatch({type: 'EDITOR_ITALIC'});
        this.close();
    }

    _onFontSizeChange(value) {
        let {dispatch} = this.props;
        dispatch({type: 'EDITOR_FONT_SIZE', value: value});
        this.close();
    }

    _onFontFamilyChange(value) {
        let {dispatch} = this.props;
        dispatch({type: 'EDITOR_FONT_FAMILY', value: value});
        this.close();
    }

    _this = this;
    renderTextColorPopup(props) {
        this._colorPopup = ChatEditorTextColorPopup.mount({
            editorStyle: props.editorStyle,
            dispatch: props.dispatch,
            ref: (r) => {
                this._colorPopup = r;
                this._colorPopup.setAnchor(this._colorControl);
            }
        });
    }

    componentDidMount() {
        super.componentDidMount();
        this.setState({
            ...this._getState(this.props)
        });
        this.renderTextColorPopup(this.props);
    }

    updateStyle(nextStyle) {
        this.setState(this._getState(nextStyle));
    }

    componentWillReceiveProps(nextProps) {
        this.setState(this._getState(nextProps));
        this.renderTextColorPopup(nextProps);
    }

    render() {
        let className = 'popup block-text-setting pre-init ' + this.state.visibility;

        return (
            <div className={className} ref={(ref) => this._ref = ref}>
                <div className="one-setting">
                    <select className="text-px-setting" onChange={(event) => this._onFontSizeChange(event.target.value)} value={this.state.fontSize}>
                        <option value="66%">8</option>
                        <option value="83%">10</option>
                        <option value="100%">12</option>
                        <option value="117%">14</option>
                    </select>
                </div>

                <div className="one-setting">
                    <p className="text-style">
                        <span className={'bold' + (this.state.bold ? ' active' : '')} onClick={this._onBoldClick}>B</span>
                        <span className={'italic' + (this.state.italic ? ' active' : '')} onClick={this._onItalicClick}>I</span>
                    </p>
                </div>

                <div className="one-setting">
                    <select className="text-family" onChange={(event) => this._onFontFamilyChange(event.target.value)} value={this.state.fontFamily}>
                        <option value="Arial, Helvetica, sans-serif">Arial</option>
                        <option value="Comic Sans MS, cursive">Comic Sans MS</option>
                        <option value="Courier New, Courier, monospace">Courier New</option>
                        <option value="Georgia, serif">Georgia</option>
                        <option value="Lucida Sans Unicode, Lucida Grande, sans-serif">Lucida Sans Unicode</option>
                        <option value="Tahoma, Geneva, sans-serif">Tahoma</option>
                        <option value="Times New Roman, Times, serif">Times New Roman</option>
                        <option value="Trebuchet MS, Helvetica, sans-serif">Trebuchet MS</option>
                        <option value="Verdana, Geneva, sans-serif">Verdana</option>
                    </select>
                </div>

                <div className="one-setting">
                    <p>
                        <span
                            className="text-color"
                            onClick={() => this._colorPopup.open()}
                            style={{backgroundColor: this.state.color}}
                            ref={(colorControl) => this._colorControl = colorControl}
                        ></span>
                        <span className="icon">▾</span>
                    </p>
                </div>
            </div>                
        )
    }
}

ChatEditorTextStylePopup.generateKey = function(props) {
    return 'room-editor-text-style-popup-' + uniqueId();
};

ChatEditorTextStylePopup.mount = function(props) { return Popup.mount(ChatEditorTextStylePopup, props) };

export default ChatEditorTextStylePopup;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ChatEditorTextStylePopup/index.js